export const cancelMultipleBillsMutation = ({ file }) => {
  var bodyFormData = new FormData();
  bodyFormData.append("file", file);
  return {
    url: `/boleto/cancelar-varios`,
    method: "post",
    data: bodyFormData,
  };
};
